import CreateTabs from "common/components/createTabs";
import { DescriptionIcon } from "services/Recruit/assets/svg/DescriptionIcon";
import { JobOpeningIcon } from "services/Recruit/assets/svg/JobOpening";
import { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormLabel,
  Grid,
  GridItem,
  Input,
  Select as ChakraSelect,
  Spinner,
  Text,
  Textarea,
} from "@chakra-ui/react";
import Select from "react-select";
import { useNavigate, useLocation } from "react-router-dom";
import { convertUtcToIst } from "services/Crm/utils/calcUtils";
import { useFormik } from "formik";
import { TaskSchema } from "common/schema";
import { constant } from "common/constant";
import { crmConstant } from "services/Crm/constant";
import colors from "common/theme/foundations/colors";
import moment from "moment";
import { toast } from "react-toastify";
import { postApi } from "common/services/api";
import { getApi } from "common/services/api";
import { globalStyles } from "common/theme/styles";
import ColorPicker from "common/components/colorDropdown";
import { useDispatch } from "react-redux";
import { getContactList, getLeadList } from "common/redux/reducers/contactLeadSlice";
import { useSelector } from "react-redux";
import SearchSelect from "common/components/autoComplete/AutoCompleteSelect";

const TaskInformation = (props) => {
  const [isChecked, setIsChecked] = useState(false);
  const userId = JSON.parse(localStorage.getItem("user"))._id;
  const [assignmentToData, setAssignmentToData] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));
  const [isLoading, setIsLoading] = useState(false);
  const [contactModelOpen, setContactModel] = useState(false);
  const [leadModelOpen, setLeadModel] = useState(false);
  const [relatedContacts, setRelatedContacts] = useState([]);

  const [isSubmit, setIsSubmit] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const initialValuesPro = location.state?.initialValuesProp || {};
  const view = location.state?.view || "";
  const [userLoading,setUserLoading] = useState(false);
  const [listLoading,setListLoading] = useState(false);

  const initialValues = {
    title: "",
    category:
      view === constant.contact
        ? constant.contact
        : view === constant.lead
          ? constant.lead
          : view === constant.accounts
            ? constant.accounts
            : view === constant.deals
              ? constant.deals
              : constant.none,
    description: "",
    notes: "",
    assignedToUser: "",
    assignmentTo:
      view === constant.contact && initialValuesPro?._id
        ? initialValuesPro._id
        : "",
    assignmentToAccount:
      view === constant.accounts && initialValuesPro?._id
        ? [initialValuesPro._id]
        : "",
    assignmentToDeal:
      view === constant.deals && initialValuesPro?._id
        ? initialValuesPro._id
        : "",
    assignmentToLead:
      view === constant.lead && initialValuesPro?._id
        ? initialValuesPro._id
        : "",
    reminder: "",
    start: convertUtcToIst(new Date()),
    end: "",
    backgroundColor: colors.black,
    borderColor: colors.white,
    textColor: colors.white,
    allDay: "No",
    display: "",
    url: "",
    priority: "not_defined",
    createBy: userId,
  };
  const [userList, setUserList] = useState([]);

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: TaskSchema,
    onSubmit: (values, { resetForm }) => {
      AddData();
    },
  });
  const {
    errors,
    touched,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = formik;
  useEffect(() => {
    setFieldValue("start", convertUtcToIst(new Date()));
  }, []);
  function onChangeHandler(e) {
    if (e.target.value.startsWith(" ")) {
      return;
    }
    setIsSubmit(false);
    handleChange(e);
  }
  const handleTextareaChange = (e, fieldName, setFieldValue) => {
  const input = e.target.value;
  const limitedText = input.slice(0, 1000); // limit to 150 characters
  setFieldValue(fieldName, limitedText);
};
  const [assignToError, setAssignToError] = useState({
    contact: "",
    lead: "",
    account: "",
    deal: "",
  });

  const AddData = async () => {
    if (values.category === "Contact" && !values.assignmentTo) {
      setAssignToError({
        ...assignToError,
        contact: "Please select contact",
      });
      return;
    }
    if (values.category === "Lead" && !values.assignmentToLead) {
      setAssignToError({
        ...assignToError,
        lead: "Please select lead",
      });
      return;
    }

    if (values.category === "Accounts" && !values.assignmentToAccount) {
      setAssignToError({
        ...assignToError,
        account: constant.accountErrorMsg,
      });
      return;
    }
    if (values.category === "Deals" && !values.assignmentToDeal) {
      setAssignToError({
        ...assignToError,
        deal: constant.dealErrorMsg,
      });
      return;
    }

    try {
      setIsLoading(true);

      if (values?.start) {
        values.start = isChecked
          ? moment(values.start).format("YYYY-MM-DD") || ""
          : moment(values.start).format("YYYY-MM-DDTHH:mm") || "";
      }
      if (values?.end) {
        values.end = isChecked
          ? moment(values.end).format("YYY-MM-DD") || ""
          : moment(values.end).format("YYYY-MM-DDTHH:mm") || "";
      }

      let response = await postApi("api/task/add", values);
      if (response.status === 200) {
        toast.success("Task Added Successfully");
        navigate(-1);
      }
    } catch (e) {
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
      setAssignToError({ lead: "", contact: "", account: "" });
      setIsSubmit(false);
      formik.resetForm();
    }
  };
  const contactData = useSelector((state) => state.contactLead.contacts);
  const leadData = useSelector((state) => state.contactLead.leads);

  const [list, setList] = useState({
    contact: contactData,
    lead: leadData,
    accounts: [],
    deals: [],
  });

  useEffect(() => {
    setList((prev) => ({
      ...prev,
      contact: contactData || [],
      lead: leadData || [],
    }));
  }, [contactData, leadData]);

  const dispatch = useDispatch()
  // const fetchDynamicData = async (id, type) => {
  //   console.log(type, "from fetch");
  //   let result = await getApi(
  //     user.role === "superAdmin"
  //       ? `api/form?moduleId=${id}`
  //       : `api/form?moduleId=${id}&createBy=${user._id}`
  //   );
  //   if (result.status === 200) {
  //     setList((prev) => ({ ...prev, [type]: result?.data?.data }));
  //   }
  // };
  const fetchDynamicData = async (id, type) => {
    setListLoading(true);
    try {
      const result = await getApi(
        user.role === "superAdmin"
          ? `api/form?moduleId=${id}`
          : `api/form?moduleId=${id}&createBy=${user._id}`
      );
      if (result.status === 200) {
        setList((prev) => ({ ...prev, [type]: result?.data?.data }));
      }
    } catch (error) {
      console.error("Error fetching dynamic data:", error);
    } finally {
      setListLoading(false);
    }
  };
  const fetchCustomDataFields = async (type) => {
    const result = await getApi(`api/custom-field/?moduleName=${type}`);
    const singaleData = result?.data?.find((item) => item?.moduleName === type);
    fetchDynamicData(singaleData?._id, type.toLowerCase());
  };

  async function getContactListData() {
    dispatch(getContactList({ fetchAllData: true }));
  }
  const fetchUserData = async () => {
    setUserLoading(true); 
    try {
      const result = await getApi("api/user/");
      setUserList(result?.data?.data);
    } catch (error) {
      console.error("Failed to fetch user data", error);
    } finally {
      setUserLoading(false); 
    }
  };
  async function getLeadListData() {
    dispatch(getLeadList({ fetchAllData: true }));
  }
  useEffect(() => {
    fetchCustomDataFields("Deals");
    fetchCustomDataFields("Accounts");
    getContactListData();
    fetchUserData();
    getLeadListData();
  }, []);
  const getListDetails = async () => {
    try {
      let result = [];
      if (values.category === "Contact") {
        result = list.contact;
      } else if (values.category === "Lead") {
        result = list.lead;
      } else if (values.category === "Accounts") {
        result = list.accounts;
      } else if (values.category === "Deals") {
        result = list.deals;
      }
      setAssignmentToData(result);
    } catch (e) {
      toast.error("Something went wrong");
    }
  };
  useEffect(() => {
    getListDetails();
  }, [values.category, list]);

  const handleBackPage = () => {
    navigate(-1);
  };
  const normalizedCategory = values.category?.toLowerCase();
  console.log(normalizedCategory, "normalizedCategory");
  const selectedId =
    normalizedCategory === "contact"
      ? values.assignmentTo
      : normalizedCategory === "accounts"
        ? values.assignmentToAccount
        : normalizedCategory === "deals"
          ? values.assignmentToDeal
          : normalizedCategory === "lead"
            ? values.assignmentToLead
            : null;

  const categoryList = list?.[normalizedCategory] || [];
  const selectedItem =
    selectedId && !categoryList.some((item) => item._id === selectedId)
      ? Object.values(list || {})
        .flat()
        .find((item) => item._id === selectedId)
      : null;

  const selectList = selectedItem
    ? [selectedItem, ...categoryList]
    : categoryList;

  const selectFieldValue = selectedId ?? "";
  const selectFieldName =
    normalizedCategory === "contact"
      ? "assignmentTo"
      : normalizedCategory === "accounts"
        ? "assignmentToAccount"
        : normalizedCategory === "deals"
          ? "assignmentToDeal"
          : "assignmentToLead";

  const getDisplayName = (item) => {
    console.log(
      values.category?.toLowerCase(),
      "values.category?.toLowerCase()"
    );
    switch (values.category?.toLowerCase()) {
      case "contact":
        return item.contactName;
      case "lead":
        return item.leadName;
      case "deals":
        return item.dealName;
      case "accounts":
        return item.accountName;
      default:
        return item.contactName;
    }
  };
  return (
    <>
      <Box className="commonPanelBody">
        <Grid templateColumns="repeat(12, 1fr)" gap={3}>
          <GridItem colSpan={{ base: 12, md: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.taskName}
              <Text color={"red"}>*</Text>
            </FormLabel>
            <Input
              fontSize="sm"
              onChange={(e) => {
                onChangeHandler(e);
              }}
              onBlur={handleBlur}
              value={values.title}
              name="title"
              placeholder={crmConstant.taskName}
              fontWeight="500"
              borderColor={errors?.title && touched?.title ? "red.300" : null}
            />
            <Text mb="10px" fontSize="sm" color={"red"}>
              {" "}
              {errors.title && touched.title && errors.title}
            </Text>
          </GridItem>
          <GridItem colSpan={{ base: 12, md: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.dueDate}
            </FormLabel>
            <Input
              type={"datetime-local"}
              fontSize="sm"
              min={values.end}
              onChange={(e) => {
                onChangeHandler(e);
              }}
              onBlur={handleBlur}
              value={values.end}
              name="end"
              fontWeight="500"
              borderColor={errors?.end && touched?.end ? "red.300" : null}
            />
            <Text mb="10px" color={"red"}>
              {" "}
              {errors.end && touched.end && errors.end}
            </Text>
          </GridItem>
          <GridItem colSpan={{ base: 12, md: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.priority}
            </FormLabel>
            <ChakraSelect
              onChange={(e) => {
                setIsSubmit(false);
                setFieldValue("priority", e.target.value);
              }}
              value={values.priority}
            >
              {crmConstant.priorityList.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </ChakraSelect>

            <Text mb="10px" color={"red"}>
              {errors.priority && touched.priority && errors.priority}
            </Text>
          </GridItem>
          <GridItem colSpan={{ base: 12, md: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {constant.status}
            </FormLabel>
            <ChakraSelect
              onChange={(e) => {
                setIsSubmit(true);
                setFieldValue("status", e.target.value);
              }}
              value={values.status}
            >
              <option value="completed">{crmConstant.completed}</option>
              <option value="todo">{crmConstant.todo}</option>
              <option value="onHold">{crmConstant.onHold}</option>
              <option value="inProgress">{crmConstant.inProgress}</option>
              <option value="pending">{crmConstant.pending}</option>
            </ChakraSelect>
            <Text mb="10px" color={"red"}>
              {errors.category && touched.category && errors.category}
            </Text>
          </GridItem>
          <GridItem colSpan={{ base: 12, md: 6 }} className="selectDropBtn">
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {crmConstant.assignToUser}
              <Text color={colors.red["600"]}>*</Text>
            </FormLabel>
            {/* <ChakraSelect
              onChange={(e) => {
                // setIsSubmit(false);
                setFieldValue("assignedToUser", e.target.value);
              }}
              value={values.assignedToUser}
              placeholder={crmConstant.assignTo}
            >
              {userList && userList.length > 0
                ? userList.map((user) => {
                  return (
                    <option value={user._id}>
                      {user?.firstName ?? ""} {user?.lastName ?? ""}
                    </option>
                  );
                })
                : []}
            </ChakraSelect> */}
            <SearchSelect
              loading={userLoading}
              options={
                userList?.map((user) => ({
                  value: user._id,
                  label: `${user.firstName ?? ""} ${user.lastName ?? ""}`,
                })) || []
              }
              value={values.assignedToUser}
              placeholder={crmConstant.assignTo}
              onSelect={(option) => setFieldValue("assignedToUser", option.value)}
            />
            <Text mb="10px" fontSize="sm" color={colors.red["600"]}>
              {errors.assignedToUser &&
                touched.assignedToUser &&
                errors.assignedToUser}
            </Text>
          </GridItem>
          <GridItem colSpan={{ base: 12, md: 6 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {constant.taskRelatedTo}
            </FormLabel>
            <ChakraSelect
              onChange={(e) => {
                setFieldValue("category", e.target.value);
                setFieldValue("assignmentTo", null);
                setFieldValue("assignmentToLead", null);
              }}
              value={values.category}
            >
              <option value={constant.none}>{constant.none}</option>
              <option value={constant.contact}>{constant.contact}</option>
              <option value={constant.lead}>{constant.lead}</option>
              <option value={constant.accounts}>{constant.account}</option>
              <option value={constant.deals}>{constant.deal}</option>
            </ChakraSelect>
            <Text mb="10px" color={"red"}>
              {errors.category && touched.category && errors.category}
            </Text>
          </GridItem>
          {["lead", "accounts", "deals", "contact"].includes(
            normalizedCategory
          ) && (
              <GridItem colSpan={{ base: 12, md: 12 }} className="selectDropBtn">
                <FormLabel
                  fontSize="sm"
                  fontWeight="500"
                  mb="8px"
                  display={"flex"}
                >
                  {
                    {
                      contact: constant.assignToContact,
                      accounts: constant.assignToAccount,
                      deals: constant.assignToDeal,
                      lead: constant.assignToLead,
                    }[normalizedCategory]
                  }
                  <Text color="red">*</Text>
                </FormLabel>

                {/* <ChakraSelect
                  value={selectFieldValue}
                  name={selectFieldName}
                  onChange={(e) => {
                    const selectedValue = e.target.value;
                    onChangeHandler(e);

                    if (["accounts", "deals"].includes(normalizedCategory)) {
                      const selectedItems = list[normalizedCategory]?.filter(
                        (item) => item._id === selectedValue
                      );
                      const contactIds = selectedItems?.flatMap(
                        (item) => item.contact || []
                      );
                      const uniqueContactIds = [...new Set(contactIds)];
                      const matchedContacts = list.contact
                        ?.filter((c) => uniqueContactIds.includes(c._id))
                        .map((contact) => ({
                          value: contact._id,
                          label: contact.contactName || "-",
                        }));
                      setRelatedContacts(matchedContacts || []);
                    }
                  }}
                  placeholder={crmConstant.assignTo}
                  fontWeight="500"
                  borderColor={
                    (normalizedCategory === "contact" &&
                      errors.assignmentTo &&
                      touched.assignmentTo) ||
                      (normalizedCategory === "accounts" &&
                        errors.assignmentToAccount &&
                        touched.assignmentToAccount) ||
                      (normalizedCategory === "deals" &&
                        errors.assignmentToDeal &&
                        touched.assignmentToDeal) ||
                      (normalizedCategory === "lead" &&
                        errors.assignmentToLead &&
                        touched.assignmentToLead)
                      ? "red.300"
                      : undefined
                  }
                >
                  {selectList.map((item) => (
                    <option key={item._id} value={item._id}>
                      {getDisplayName(item)}
                    </option>
                  ))}
                </ChakraSelect> */}

              <SearchSelect
                loading={listLoading}
                name={selectFieldName}
                value={selectFieldValue}
                placeholder={crmConstant.assignTo}
                options={selectList.map((item) => ({
                  value: item._id,
                  label: getDisplayName(item),
                }))}
                onSelect={(option) => {
                  const syntheticEvent = {
                    target: {
                      name: selectFieldName,
                      value: option.value,
                    },
                  };
                  onChangeHandler(syntheticEvent);

                  if (["accounts", "deals"].includes(normalizedCategory)) {
                    const selectedItems = list[normalizedCategory]?.filter(
                      (item) => item._id === option.value
                    );
                    const contactIds = selectedItems?.flatMap((item) => item.contact || []);
                    const uniqueContactIds = [...new Set(contactIds)];
                    const matchedContacts = list.contact
                      ?.filter((c) => uniqueContactIds.includes(c._id))
                      .map((contact) => ({
                        value: contact._id,
                        label: contact.contactName || "-",
                      }));
                    setRelatedContacts(matchedContacts || []);
                  }
                }}
                className={
                  (normalizedCategory === "contact" && errors.assignmentTo && touched.assignmentTo) ||
                    (normalizedCategory === "accounts" && errors.assignmentToAccount && touched.assignmentToAccount) ||
                    (normalizedCategory === "deals" && errors.assignmentToDeal && touched.assignmentToDeal) ||
                    (normalizedCategory === "lead" && errors.assignmentToLead && touched.assignmentToLead)
                    ? "border-red-300"
                    : ""
                }
              />


                {normalizedCategory === "contact" &&
                  assignToError.contact &&
                  !values.assignmentTo &&
                  isSubmit && (
                    <Text mb="10px" fontSize="sm" color={colors.red["600"]}>
                      Please select contact
                    </Text>
                  )}

                {normalizedCategory === "lead" &&
                  assignToError.lead &&
                  !values.assignmentToLead &&
                  isSubmit && (
                    <Text mb="10px" fontSize="sm" color={colors.red["600"]}>
                      Please select lead
                    </Text>
                  )}

                {normalizedCategory === constant.accounts &&
                  assignToError.account &&
                  !values.assignmentToAccount &&
                  isSubmit && (
                    <Text mb="10px" fontSize="sm" color={colors.red["600"]}>
                      {constant.accountErrorMsg}
                    </Text>
                  )}

                {normalizedCategory === constant.deals &&
                  assignToError.deal &&
                  !values.assignmentToDeal &&
                  isSubmit && (
                    <Text mb="10px" fontSize="sm" color={colors.red["600"]}>
                      {constant.dealErrorMsg}
                    </Text>
                  )}

                {/* Conditionally render related contacts for Accounts/Deals */}
                {["accounts", "deals"].includes(normalizedCategory) &&
                  relatedContacts.length > 0 && (
                    <GridItem mt={4} colSpan={{ base: 6 }}>
                      <FormLabel fontSize="sm" fontWeight="500" mb="8px">
                        {constant.selectContacts} {values.category}
                      </FormLabel>

                      {/* <Select
                        placeholder="Select related contacts"
                        name="attendesContact"
                        options={relatedContacts}
                        onChange={(selected) => {
                          const selectedContactId = selected?.value || "";
                          setFieldValue("assignmentTo", selectedContactId);
                        }}
                        value={
                          relatedContacts.find(
                            (item) => item.value === values.assignmentTo
                          ) || null
                        }
                        className="basic-multi-select"
                        classNamePrefix="select"
                      /> */}
                    <SearchSelect
                      name="attendesContact"
                      placeholder="Select related contacts"
                      options={relatedContacts}
                      value={values.assignmentTo || []}
                      onSelect={({ value }) => setFieldValue("assignmentTo", value)}
                    />

                      <Text mb="10px" color="red" fontSize="sm">
                        {errors.assignmentTo &&
                          touched.assignmentTo &&
                          errors.assignmentTo}
                      </Text>
                    </GridItem>
                  )}
              </GridItem>
            )}

          <GridItem
            colSpan={{ base: 12, md: values.category === "None" ? 12 : 12 }}
          >
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {constant.taskDescription}
            </FormLabel>
            <Textarea
              fontSize="sm"
              onChange={(e) => {
                onChangeHandler(e);
                handleTextareaChange(e, "description", setFieldValue);
                
              }}
              onBlur={handleBlur}
              value={values.description}
              name="description"
              placeholder={crmConstant.description}
              fontWeight="500"
            />
              <Text
    mt={1}
    fontSize="xs"
    textAlign="right"
    color={(values.description?.length || 0) === 1000 ? "red.500" : "gray.500"}
  >
    {0 + (values.description?.length || 0)}/1000
  </Text>
            <Text mb="10px" color={"red"}>
              {" "}
              {errors.description && touched.description && errors.description}
            </Text>
          </GridItem>
          <GridItem colSpan={{ base: 12, sm: 3 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {constant.bgcolor}
            </FormLabel>
            {/* <Input
                        type="color"
                        fontSize="sm"
                        onChange={(e) => {
                          onChangeHandler(e);
                        }}
                        onBlur={handleBlur}
                        value={values.backgroundColor}
                        name="backgroundColor"
                        fontWeight="500"
                        borderColor={
                          errors?.backgroundColor && touched?.backgroundColor
                            ? "red.300"
                            : null
                        }
                        className="roundedColorInput"
                      /> */}
            <ColorPicker
              name="backgroundColor"
              value={values.backgroundColor}
              onSelect={(e) => {
                onChangeHandler(e);
              }}
              onBlur={handleBlur}
              errors={errors}
              touched={touched}
            />

            <Text mb="10px" color={"red"}>
              {" "}
              {errors.backgroundColor &&
                touched.backgroundColor &&
                errors.backgroundColor}
            </Text>
          </GridItem>
          <GridItem colSpan={{ base: 12, sm: 3 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {constant.borderolor}
            </FormLabel>
            {/* <Input
              fontSize="sm"
              type="color"
              onChange={(e) => {
                onChangeHandler(e);
              }}
              onBlur={handleBlur}
              value={values.borderColor}
              name="borderColor"
              placeholder="borderColor"
              fontWeight="500"
              borderColor={
                errors?.borderColor && touched?.borderColor ? "red.300" : null
              }
              className="roundedColorInput"
            /> */}
            <ColorPicker
              name="borderColor"
              value={values.borderColor}
              onSelect={(e) => {
                onChangeHandler(e);
              }}
              onBlur={handleBlur}
              errors={errors}
              touched={touched}
            />
            <Text mb="10px" color={"red"}>
              {" "}
              {errors.borderColor && touched.borderColor && errors.borderColor}
            </Text>
          </GridItem>
          <GridItem colSpan={{ base: 12, sm: 3 }}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              mb="8px"
            >
              {constant.textColor}
            </FormLabel>
            {/* <Input
              fontSize="sm"
              type="color"
              onChange={(e) => {
                onChangeHandler(e);
              }}
              onBlur={handleBlur}
              value={values.textColor}
              name="textColor"
              placeholder="textColor"
              fontWeight="500"
              textColor={
                errors?.textColor && touched?.textColor ? "red.300" : null
              }
              className="roundedColorInput"
            /> */}
            <ColorPicker
              name="textColor"
              value={values.textColor}
              onSelect={(e) => {
                onChangeHandler(e);
              }}
              onBlur={handleBlur}
              errors={errors}
              touched={touched}
            />
            <Text mb="10px" color={"red"}>
              {" "}
              {errors.textColor && touched.textColor && errors.textColor}
            </Text>
          </GridItem>
        </Grid>
      </Box>
      <Box className="createJobOpening-tabsPanelFooter">
        <Button
          size="sm"
          sx={{
            marginRight: 1,
            textTransform: "capitalize",
          }}
          variant="outline"
          onClick={handleBackPage}
          className="cancelBtn theme-btn2"
        >
          {crmConstant.back}
        </Button>
        <Button
          className="nextBtn"
          variant="primary"
          onClick={() => {
            setIsSubmit(true);
            handleSubmit();
          }}
        >
          {isLoading ? (
            <Spinner
              size={20}
              paddingRight={5}
              border={`3px solid ${globalStyles.colors.loaderBorder}`}
              borderTop={`1px solid ${globalStyles.colors.transparent}`}
            />
          ) : (
            ""
          )}{" "}
          {constant.save}
        </Button>
      </Box>
    </>
  );
};

const CreateTask = () => {
  const navigate = useNavigate();

  const handleBackPage = () => {
    navigate(-1);
  };

  const tabsData = [
    { label: crmConstant.taskInformation, Icon: JobOpeningIcon },
  ];

  const panelsData = [<TaskInformation />];

  return (
    <CreateTabs
      tabsData={tabsData}
      panelsData={panelsData}
      handleBackPage={handleBackPage}
      pageTitle={crmConstant.createTask}
    />
  );
};

export default CreateTask;
